import type { FaireProductEntity } from "../../entity_types/product";

export const p_szrb5cu7cs: FaireProductEntity = {
  token: "p_szrb5cu7cs",
  type: "product",
  name: "Satoneko Porcelain Tayo Medium Bowl – 6 in. Round, 19 oz JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/6f1b856b90c0c1af2323ead82bd03064b546fd7e5f912a46212f332ac004bf86.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37a613b803486a4273a9540027c30b735e6504e55c464e43b71db486d1dde7a3.jpeg",
    "https://cdn.faire.com/fastly/53a4b43268ff2afe6d25a1b8ce47e757676e099ea6feaa2352e54823391a21ec.jpeg",
    "https://cdn.faire.com/fastly/35e86981258e130f8998b8faf7aa534a5ee16decde449124afed18c559964dfc.jpeg",
    "https://cdn.faire.com/fastly/cd6aacf2fcb01583ccc2e4a7986bee1e64cd9a04ed7ae6601d8812350c496363.jpeg",
    "https://cdn.faire.com/fastly/d43ac26a95c0f72ae5c3976390777f2a93ce1b67148a2382a9ae4ecea10ec150.jpeg"
  ],
  priceDollars: 3.5,
  description: "Bring a refined, restaurant-ready look to the table with this 6\" tayo medium bowl in the Satoneko design. A multipurpose bowl for rice bowls, soups, salads, noodles and side dishes. Made in Japan from durable porcelain, it is built for busy restaurants, sushi bars, ramen shops, cafés and catering, while looking just as good on the family dinner table.\n\nFeatures\n\n * Quality porcelain: a classic glazed finish for everyday restaurant and home use \n * Easy care: microwave and dishwasher safe \n * Coordinated collection: mix with other Tayo medium bowl designs, rice bowls and ramen bowls for a coordinated or mix-and-match table setting \nSpecifications\n\n * Size: 6\" Dia x 2.75\" H \n * Capacity: 19 fl oz \n * Material: Porcelain \n * Series: Tayo \n * Design: Satoneko \n * Inner pack: 6 \n * Case pack: 48 \n * Origin: Japan \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 7.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:53.789Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
